import { JsonUtils } from '../../utils/json.util'

export class Address {
    private _street?: string
    private _number?: string
    private _district?: string
    private _complement?: string
    private _municipality?: string
    private _uf?: string
    private _zip_code?: string

    get street(): string | undefined {
        return this._street
    }

    set street(value: string | undefined) {
        this._street = value
    }

    get number(): string | undefined {
        return this._number
    }

    set number(value: string | undefined) {
        this._number = value
    }

    get district(): string | undefined {
        return this._district
    }

    set district(value: string | undefined) {
        this._district = value
    }

    get complement(): string | undefined {
        return this._complement
    }

    set complement(value: string | undefined) {
        this._complement = value
    }

    get municipality(): string | undefined {
        return this._municipality
    }

    set municipality(value: string | undefined) {
        this._municipality = value
    }

    get uf(): string | undefined {
        return this._uf
    }

    set uf(value: string | undefined) {
        this._uf = value
    }

    get zip_code(): string | undefined {
        return this._zip_code
    }

    set zip_code(value: string | undefined) {
        this._zip_code = value
    }

    public fromJSON(json: any): Address {
        if (!json) return this
        if (typeof json === 'string' && JsonUtils.isJsonString(json)) {
            json = JSON.parse(json)
        }

        if (json.street !== undefined) this.street = json.street
        if (json.number !== undefined) this.number = json.number
        if (json.district !== undefined) this.district = json.district
        if (json.complement !== undefined) this.complement = json.complement
        if (json.municipality !== undefined) this.municipality = json.municipality
        if (json.uf !== undefined) this.uf = json.uf
        if (json.zip_code !== undefined) this.zip_code = json.zip_code

        return this
    }

    public toJSON(): any {
        return {
            street: this.street,
            number: this.number,
            district: this.district,
            complement: this.complement,
            municipality: this.municipality,
            uf: this.uf,
            zip_code: this.zip_code
        }
    }
}
